import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

const ClaycoForm = ({schema, defaultValues, onSubmit, onError, children}) => {
    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: defaultValues
      });

    return ( 
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit, onError)} autoComplete="off">
                {children}
            </form>
        </FormProvider>
     );
}
 
export default ClaycoForm;